<template>
    <div>
         <span style="width:100%;" v-for="(item,k) in this.$store.getters.getActiveBiomarker"  v-bind:key="k">
            <NavBar_Gene v-bind:item="item"></NavBar_Gene>

            <div>
                    <v-container>
                        <v-row style="text-align: center;width:100%;" v-for="(item,k) in this.$store.getters.getActiveBiomarker"  v-bind:key="k">
                        <v-col cols="12" md="12" lg="12" xl="12" style="text-align:center;">
                            <v-card
                             class="elevation-2 content-box"
                            >
                            <Results_ClinicalSignificance v-bind:item="item"></Results_ClinicalSignificance>

                                 </v-card>

                        </v-col>
                   </v-row>
                </v-container>
            </div>

         </span>
    </div>
</template>
<script>
import Loading from 'vue-loading-overlay';
import NavBar_Gene from '@/components/navbars/NavBar_Gene';
import active_variants from "@/methods/active_variants";
import Results_ClinicalSignificance from '@/components/query_result_components/Results_ClinicalSignificance.vue';

export default {
    name: 'GeneTreatments',
    components: {
        Loading,
        NavBar_Gene,
        Results_ClinicalSignificance,
    },
    data: () => ({
        isLoading: false,
        fullPage: true,
        overlay: false,
        open: ['metakb'],
        sunburst_plot: "",
                sortStates: {
            'gene': 0,
            'variant': 0,
            'disease': 0,
            'drugs': 0,
            'evidence_level': 0,
            'response': 0,
            'citation_url': 0,
            'source': 0
        },
        iconStatesUp: {
            'gene': 'mdi-arrow-up-thin',
            'variant': 'mdi-arrow-up-thin',
            'disease': 'mdi-arrow-up-thin',
            'drugs': 'mdi-arrow-up-thin',
            'evidence_level': 'mdi-arrow-up-thin',
            'response': 'mdi-arrow-up-thin',
            'citation_url': 'mdi-arrow-up-thin',
            'source': 'mdi-arrow-up-thin'
        },
        iconStatesDn: {
            'gene': 'mdi-arrow-down-thin',
            'variant': 'mdi-arrow-down-thin',
            'disease': 'mdi-arrow-down-thin',
            'drugs': 'mdi-arrow-down-thin',
            'evidence_level': 'mdi-arrow-down-thin',
            'response': 'mdi-arrow-down-thin',
            'citation_url': 'mdi-arrow-down-thin',
            'source': 'mdi-arrow-down-thin'
        },
    }),
    created: async function() {
        this.isLoading=true
        await active_variants.loadActiveBiomarkerGene(this.$route.params.id)
        this.isLoading=false
    }
}
</script>
<style>
</style>
